import { LocalStorageStore, registerStore } from '@stack/react-shared'

// Separate module so it evaluates before any `StoredSubject` singleton is constructed
// (ES imports are hoisted; inline code in main.tsx would run too late).
registerStore(new LocalStorageStore())
